import { render, staticRenderFns } from "./Ceramic.vue?vue&type=template&id=331c3bc0&scoped=true&"
import script from "./Ceramic.vue?vue&type=script&lang=js&"
export * from "./Ceramic.vue?vue&type=script&lang=js&"
import style0 from "./Ceramic.vue?vue&type=style&index=0&id=331c3bc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331c3bc0",
  null
  
)

export default component.exports